<template>
  <div class="space-y-4">
    <div class="rounded bg-white p-4">
      <div class="flex space-x-4">
        <BaseFormCheckbox v-model="forceOrderItemsVisibility" label="Order items" />
        <BaseFormCheckbox
          v-show="forceOrderItemsVisibility"
          v-model="forceRequirementsVisibility"
          label="Specs"
        />
        <BaseFormCheckbox v-model="forceTasksVisibility" label="Tasks" />
      </div>
    </div>
    <Order
      ref="order"
      v-for="order in orders"
      :key="order.uuid"
      :order="order"
      :project="project"
      :force-order-items-visibility="forceOrderItemsVisibility"
      :force-requirements-visibility="forceRequirementsVisibility"
      :force-tasks-visibility="forceTasksVisibility"
    />
  </div>
</template>

<script>
import Order from '@/components/ProjectManagement/Order.vue';

export default {
  name: 'Management',
  components: {
    Order,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      forceOrderItemsVisibility: true,
      forceRequirementsVisibility: false,
      forceTasksVisibility: false,
    };
  },
  computed: {
    project() {
      return this.$store.state.entities.projects.byId[this.projectId];
    },
    orders() {
      return this.$store.getters['ui/projectOrders/orders'];
    },
    tasks() {
      return this.$store.getters['ui/projectTasks/tasksByProject'](this.projectId);
    },
  },
  created() {
    this.load();
  },
  destroyed() {
    this.$store.dispatch('ui/projectOrders/clear');
    this.$store.dispatch('ui/projectTasks/clear', { projectId: this.projectId });
  },
  methods: {
    async load() {
      try {
        await Promise.all([this.loadOrders(), this.loadTasks()]);
      } catch (error) {
        //
      }
    },
    async loadOrders() {
      try {
        await this.$store.dispatch({
          type: 'ui/projectOrders/load',
          id: this.projectId,
          params: {
            include: 'supplier',
          },
        });
      } catch (error) {
        //
      }
    },
    async loadTasks() {
      try {
        await this.$store.dispatch({
          type: 'ui/projectTasks/load',
          projectId: this.projectId,
          params: {
            include: 'linksCount,mediaCount,notesCount,userAssigned,accountAssigned',
          },
        });
      } catch (error) {
        //
      }
    },
    refreshOrderItems() {
      if (!this.$refs.order) {
        return;
      }

      this.$refs.order.forEach((order) => {
        order.load();
      });
    },
  },
};
</script>
